import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'priorityMedias',
  isDragable: true,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  getURL: 'mainHubs/mainHubId/composeExperiences',
  sessionParams: ['mainHubId'],
  emptyMessage: "There are no medias available for this app.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter: true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the media.',
    },
    {
      attributeName: 'mediaLink',
      label: 'Link to Media',
      type: FormInputTypes.LINK,
      icon: IconType.LINK,
      helpText: 'Link to the media edit form',
      canOrder: false,
      canFilter: false,
    },
  ],
};